import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Row, Slider, UploadFile } from 'antd';
import React, { FC, Fragment, useRef, useState } from 'react';
import ReactAvatarEditor, { Position } from 'react-avatar-editor';

import { JCMSCTA } from '../../../JCMSCTA';
import { TRANSLATION_CODES } from '../../constants';
import { UploadFileClass } from './../../classes/UploadFileClass';
import { useCompositorContext } from './../CompositorProvider';

interface JCropImageProps {
    file: UploadFile,
    onCancel: () => void,
    onSave: (file: UploadFile) => void
}
export const JCropImage: FC<JCropImageProps> = props => {
    const { translate, avatarShape } = useCompositorContext()
    const [position, setPosition] = useState<Position>({ x: 0.5, y: 0.5 })
    const [scale, setScale] = useState<number>(1)
    const setEditorRef = useRef<ReactAvatarEditor>(null)

    const minScale = 1
    const maxScale = 2
    const stepScale = 0.01

    const onSave = () => {
        if (setEditorRef.current) {
            const canvasScaled = setEditorRef.current.getImageScaledToCanvas()
            canvasScaled.toBlob((blob => {
                if (blob) {
                    const name = props.file?.name || `upload-${new Date().valueOf()}`
                    const _newFile = new File([blob], name, { type: blob.type });
                    const newUploadFile = new UploadFileClass(_newFile, name, 0)
                    props.onSave(newUploadFile)
                }
            }))
        }
    }
    return (
        <Fragment>
            <div style={{ maxWidth: '255px', margin: '0 auto' }}>

                <ReactAvatarEditor

                    ref={setEditorRef}
                    borderRadius={avatarShape === 'square' ? 0 : 100}
                    image={props.file.originFileObj as any}
                    onPositionChange={setPosition}
                    position={position}
                    scale={scale}
                    className="editor-canvas"
                />
                <Row className="zoom-container">
                    <MinusCircleOutlined
                        aria-hidden={true}
                        className={"less " + (scale <= minScale && "disabled")}
                        disabled={scale <= minScale}
                        onClick={() => setScale(prev => prev - stepScale * 10)}
                    />
                    <div className='slider-container'>
                        <Slider
                            className='slider'
                            min={minScale}
                            tooltip={{ open: false }}
                            trackStyle={{ background: '#f5f5f5' }}
                            max={maxScale}
                            onChange={setScale}
                            value={scale}
                            step={stepScale}
                        />
                    </div>
                    <PlusCircleOutlined
                        aria-hidden={true}
                        className={"plus " + (scale >= maxScale && "disabled")}
                        disabled={scale >= maxScale}
                        onClick={() => setScale(prev => prev + stepScale * 10)}
                    />
                </Row>
            </div>
            <div className='form-buttons'>
                <JCMSCTA title={translate(TRANSLATION_CODES.CROP_CANCEL)} color='default' action={() => props.onCancel()} type='BUTTON' />
                <JCMSCTA title={translate(TRANSLATION_CODES.CROP_SAVE)} action={onSave} type='BUTTON' />
            </div>
        </Fragment>
    )
}